import React, {Component} from 'react';
import AuthService from './authService';
/*  higher order component is generally a function which takes in a component and return another enhanced component.
    Head to https://facebook.github.io/react/docs/higher-order-components.html to learn more about them.
 */
export default function withAuth(AuthComponent) {

    return class AuthWrapped extends Component {
        constructor() {
            super();
            this.state = {
                user: null
            }
        }

        componentWillMount() {
            if (!AuthService.loggedIn()) {
                this.props.history.replace('/login')
            } else {
                try {

                    this.setState({
                        user: JSON.parse(AuthService.getUser())
                    })
                } catch (err) {
                    AuthService.logout()
                    this.props.history.replace('/login')
                }
            }
        }

        render() {
            if (this.state.user) {
                return (
                    <AuthComponent history={this.props.history} user={this.state.user} {...this.props}  />
                )
            } else {
                return null
            }
        } // end render
    } // end component
} // end class
